import { translate } from '@vimeo/i18n-runtime';
import { ReportModal } from '@vimeo/report-modal';

import { ReportReasons } from './constants';
import { useReportVideo } from './use-report-video';

export interface ReportVideoProps {
  clipId: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmitReport: () => void;
}

export const ReportVideoModal = ({ clipId, isOpen, onClose, onSubmitReport }: ReportVideoProps) => {
  const { reportReason, setReportReason, resetReason, isPosting, postReport } = useReportVideo({
    clipId,
    // Fire the caller's callback (analytics) only on a confirmed success —
    // `postReport` resolves even when the API fails.
    onSuccess: onSubmitReport,
  });

  const onCloseCleanup = () => {
    // Reset state and close modal
    resetReason();
    onClose();
  };

  const submitReport = async () => {
    // Post report, reset form, close. The modal closes itself on submit
    // regardless of outcome; the success callback fires via the hook.
    await postReport(reportReason);
    onCloseCleanup();
  };

  return (
    <ReportModal
      header={translate('Report this video')}
      cta={translate('Why are you reporting this video?')}
      reasons={ReportReasons}
      isOpen={isOpen}
      isPosting={isPosting}
      reportReason={reportReason}
      setReportReason={setReportReason}
      onCloseCleanup={onCloseCleanup}
      submitReport={submitReport}
    />
  );
};
